interface DueDatePillProps {
  dueDate: string | null
  isDone: boolean
}

export function DueDatePill({ dueDate, isDone }: DueDatePillProps) {
  if (!dueDate) return null

  const date = new Date(dueDate)
  const isOverdue = !isDone && date.getTime() < Date.now()
  const label = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })

  return (
    <span
      style={{
        fontSize: 'var(--text-xs)',
        fontWeight: 600,
        color: isOverdue ? 'var(--danger)' : 'var(--text-muted)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      {isOverdue ? '⚠' : '📅'} {label}
    </span>
  )
}
